import type { AthleteNoteDto, AthleteNoteInputDto } from "@/modules/sessions/gateway/sessionBlockDto"
import type { AthleteNoteFormikType } from "@/modules/sessions/sessionForm/blocks/noteBlock/noteFormikTypes"

export class SessionBlockAthleteNoteEntity {
  id: string
  orderIndex: number
  note: string

  private constructor(sessionBlockAthleteNote: SessionBlockAthleteNoteEntity) {
    this.id = sessionBlockAthleteNote.id
    this.orderIndex = sessionBlockAthleteNote.orderIndex
    this.note = sessionBlockAthleteNote.note
  }

  static fromDto(dto: AthleteNoteDto): SessionBlockAthleteNoteEntity {
    return new SessionBlockAthleteNoteEntity({
      id: dto.id,
      orderIndex: dto.orderIndex,
      note: dto.note,
    })
  }

  static fromEntityToFormik(entity: SessionBlockAthleteNoteEntity): AthleteNoteFormikType {
    return {
      id: entity.id,
      note: entity.note,
    }
  }

  static fromEntityToInputDto(entity: SessionBlockAthleteNoteEntity): AthleteNoteInputDto {
    return {
      id: entity.id,
      note: entity.note,
      orderIndex: entity.orderIndex,
    }
  }

  static fromFormikToInputDto(formik: AthleteNoteFormikType, orderIndex: number): AthleteNoteInputDto {
    if (!formik.note) throw new Error("Note is required") // This should never happen because the formik is validated
    return {
      id: formik.id,
      note: formik.note,
      orderIndex: orderIndex,
    }
  }
}
